/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  API_URL: process.env.REACT_APP_API_URL,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  WS_URL: process.env.REACT_APP_WS_URL,
  FAST_POLLING_DELAY: 10000, //10 secs
  SLOW_POLLING_DELAY: 60000, //1min
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  ENVIRONMENT: process.env.REACT_APP_ENV,
  APP_VERSION: `v${process.env.REACT_APP_VERSION}`,
  STATICS_URL: process.env.REACT_APP_STATICS_URL,
};
